import { render, staticRenderFns } from "./News.vue?vue&type=template&id=04b4a9ec&scoped=true"
import script from "./News.vue?vue&type=script&lang=js"
export * from "./News.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/style.css?vue&type=style&index=0&id=04b4a9ec&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b4a9ec",
  null
  
)

export default component.exports